import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { userSchema } from '../schemas/user.schema';

const requestSchema = userSchema
  .omit({
    assignments: true,
  })
  .partial()
  .required({ externalId: true });

/**
 * Update a single User by its External ID
 * @param externalId External ID of the User to update
 * @param user Updated User details
 * @returns A data object to indicate success
 */
export function putUsersExternalId(
  this: unknown,
  externalId: string,
  user: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersUrl}/${encodeURIComponent(
          externalId
        )}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify(user),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.object({
          success: z.boolean(),
        }),
      })
    )
  );
}
